import {
	SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT,
	SYS_SPACE_FIXED_100,
	SYS_SPACE_FIXED_150,
	SYS_SPACE_FIXED_200,
	SYS_SPACE_FIXED_300,
	SYS_SPACE_FIXED_400,
	SYS_SPACE_FIXED_50,
} from '@oneaudi/unified-web-alpha-common';

import styled from 'styled-components';
import { fadeIn } from '~/components/image-selection-tile/style/image-selection-tile-style';

export const SelectionContainer = styled.div<{ items?: number }>`
	display: ${({ items }) => (items && items > 0 ? 'block' : 'none')};

	.subtitle {
		padding-top: ${SYS_SPACE_FIXED_400};
		padding-bottom: ${SYS_SPACE_FIXED_50};
		margin-bottom: ${SYS_SPACE_FIXED_200};
	}

	.error {
		padding-top: ${SYS_SPACE_FIXED_300};
	}
`;
export const Header = styled.div`
	.steps {
		color: ${(props) => props.theme.sys.color.text.copy.default};
		margin-bottom: ${SYS_SPACE_FIXED_50};
	}

	p {
		color: ${SYS_COLOR_SURFACE_NEUTRAL_300_LIGHT};
	}
`;
export const FiltersContainer = styled.div`
	display: flex;
	flex-flow: column;
	gap: ${SYS_SPACE_FIXED_200};
	.filter-tags {
		padding-bottom: ${SYS_SPACE_FIXED_100};
		display: flex;
		gap: ${SYS_SPACE_FIXED_100};
		flex-wrap: wrap;
	}

	.general-disclaimer {
		animation: ${fadeIn} 0.8s ease;
		margin-top: -4px;
		margin-bottom: ${SYS_SPACE_FIXED_200};
	}
`;
export const TilesContainer = styled.div`
	margin-top: ${SYS_SPACE_FIXED_300};
	transition: all 0.6s ease;

	.inner-container {
		display: flex;
		flex-direction: column;
		gap: ${SYS_SPACE_FIXED_200};
		margin-bottom: ${SYS_SPACE_FIXED_300};
	}

	.inner-container-sub-families {
		display: flex;
		gap: ${SYS_SPACE_FIXED_200};
		margin-bottom: ${SYS_SPACE_FIXED_300};
	}

	.inner-container-categories {
		display: flex;
		flex-direction: column;
	}

	.category-name {
		padding-bottom: ${SYS_SPACE_FIXED_150};
	}

	.divider {
		margin-bottom: ${SYS_SPACE_FIXED_300};
	}

	.category-wrapper:last-child {
		.inner-container {
			margin-bottom: 0;
		}
		.divider {
			display: none;
		}
	}
`;

export const TileContainer = styled.div<{ $centerItems?: boolean }>`
	display: flex;
	align-items: ${({ $centerItems }) => ($centerItems ? 'center' : 'flex-start')};
	gap: ${SYS_SPACE_FIXED_150};
`;

export const TileInformationContainer = styled.div`
	.disclaimer-wrapper {
		margin-top: ${SYS_SPACE_FIXED_200};
	}

	.title {
		color: ${(props) => props.theme.sys.color.text.headline.default};
	}
`;

export const SubFamilyContainer = styled.div`
	animation: ${fadeIn} 0.8s ease;

	.family-title {
		margin-bottom: ${SYS_SPACE_FIXED_200};
		font-size: 14px;
	}

	.family-price {
		height: ${SYS_SPACE_FIXED_300};
		padding-bottom: ${SYS_SPACE_FIXED_50};
		margin-bottom: ${SYS_SPACE_FIXED_200};
		margin-top: ${`-${SYS_SPACE_FIXED_150}`};
	}
`;
